// src/services/tokenService.ts

// This is a FRONTEND service for managing the authentication token
// in the browser's localStorage and sessionStorage

let tokenCache: string | null = null;

export const tokenService = {
  setToken: (token: string) => {
    console.log('🔑 tokenService.setToken called', token ? `Token (${token.substring(0, 20)}...)` : 'Empty token');
    tokenCache = token;
    localStorage.setItem('token', token);
    // Also store in sessionStorage as backup
    sessionStorage.setItem('token', token);
  },

  getToken: (): string | null => {
    // First check cache
    if (tokenCache) {
      console.log('🔑 tokenService.getToken - from cache');
      return tokenCache;
    }
    
    // Then check localStorage
    let token = localStorage.getItem('token');
    if (token) {
      console.log('🔑 tokenService.getToken - from localStorage');
      tokenCache = token;
      return token;
    }
    
    // Finally check sessionStorage
    token = sessionStorage.getItem('token');
    if (token) {
      console.log('🔑 tokenService.getToken - from sessionStorage');
      tokenCache = token;
      // Sync to localStorage
      localStorage.setItem('token', token);
      return token;
    }
    
    console.log('🔑 tokenService.getToken - No token found');
    return null;
  },

  clearToken: () => {
    console.log('🗑️ tokenService.clearToken called');
    tokenCache = null;
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
  },

  isTokenValid: (): boolean => {
    const token = tokenService.getToken();
    return !!token && token.length > 0;
  },

  // Listen for token changes in other tabs
  listen: (callback: (token: string | null) => void) => {
    const handler = (event: StorageEvent) => {
      if (event.key === 'token') {
        const newToken = event.newValue;
        tokenCache = newToken;
        callback(newToken);
      }
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }
};